import { useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { safeParseInt, setDocumentTitle } from "shared/util"

import { useTenant } from "features/tenant/context"

import {
	Alert, Container, ContainerProps
} from "@mui/material"

import { ErrorInfo } from "components/controls/errorInfo"
import { Loading } from "components/controls/loading"

import { useGetGuideLine } from "interface/guideLine"
import { useTopBar } from "components/topBar/container"
import { useSideMenu } from "components/sideMenu/container"

type GuideLinePageProps = {
  topBarState: ReturnType<typeof useTopBar>
  sideMenuState: ReturnType<typeof useSideMenu>
} & ContainerProps
export const GuideLinePage = ({
	topBarState: { setBreadCrumbs },
	sideMenuState: { setActivePage },
	...others
}: GuideLinePageProps) => {
	const tenant = useTenant()
  const [params] = useSearchParams()
  const guideLineId = safeParseInt(params.get('guideLineId')) ?? null
  const guideLineState = useGetGuideLine(guideLineId)
	const guideLine = useMemo(() => guideLineState.data, [guideLineState])

	useEffect(
    () => {
      if (guideLine) setBreadCrumbs([{ label: guideLine.guideLineName }])
			setDocumentTitle(guideLine?.guideLineName, tenant.tenantName)
			setActivePage('guideLine')
    },
    [tenant, guideLine, setBreadCrumbs, setActivePage]
  )
	if (!guideLineId) return <Alert severity="error" sx={{ wordBreak: 'break-all' }}>パラメータ不正</Alert>
  if (guideLineState.loading) return <Loading/>
  if (guideLineState.error) return <ErrorInfo error={guideLineState.error}/>
  if (!guideLine) return <></>
	
	return (
		<Container
			sx={{ maxHeight: '100%', overflow: 'hidden', padding: 2 }}
			{...others}
		>
		</Container>
	)
}